import { api } from "@api/api";
import { PromocodeBatch } from "@modules/promocodeBatches/types";
import { PromocodeBatchFormValues } from "@modules/promocodeBatches/validations";

export async function createPromocodeBatchService(data: PromocodeBatchFormValues): Promise<PromocodeBatch> {
  const { data: promocode } = await api.post<PromocodeBatch>("v1/promocode_batch_admin/", data);

  return promocode;
}
